import {
    GET_BILLING_CODE_LOADING,
    GET_BILLING_CODE_SUCCESS,
    GET_BILLING_CODE_REJECT,
} from "../../actions/billingCode/getAll";

import {
    GET_BILLING_CODE_ID_LOADING,
    GET_BILLING_CODE_ID_SUCCESS,
    GET_BILLING_CODE_ID_REJECT,
} from "../../actions/billingCode/getId";

import {
    POST_BILLING_CODE_LOADING,
    POST_BILLING_CODE_SUCCESS,
    POST_BILLING_CODE_REJECT,
    POST_BILLING_CODE_RESET,
} from "../../actions/billingCode/post";

import {
    PUT_BILLING_CODE_LOADING,
    PUT_BILLING_CODE_SUCCESS,
    PUT_BILLING_CODE_REJECT,
    PUT_BILLING_CODE_RESET,
} from "../../actions/billingCode/put";

import {
    DELETE_BILLING_CODE_LOADING,
    DELETE_BILLING_CODE_SUCCESS,
    DELETE_BILLING_CODE_REJECT,
    DELETE_BILLING_CODE_RESET,
} from "../../actions/billingCode/delete";

import {
    GET_BILLING_CODE_ODOO_LOADING,
    GET_BILLING_CODE_ODOO_SUCCESS,
    GET_BILLING_CODE_ODOO_REJECT,
} from "../../actions/billingCode/getOdooProducts";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
    detail: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    post: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    put: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    delete: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    odooProducts: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
}

const billingCodeReducer = (state = stateInit, action) => {
    switch (action.type) {
        // ------------- GET ALL --------------------
        case GET_BILLING_CODE_LOADING: return {
            ...state,
            isLoading: true,
            isSuccess: false,
            isReject: false,
            data: [],
            error: {},
        }
        case GET_BILLING_CODE_SUCCESS: return {
            ...state,
            isLoading: false,
            isSuccess: true,
            isReject: false,
            error: {},
            ...action.payload,
        }
        case GET_BILLING_CODE_REJECT: return {
            ...state,
            isLoading: false,
            isSuccess: false,
            isReject: true,
            data: [],
            error: action.payload?.response?.data
        }

        // ------------- GET BY ID --------------------
        case GET_BILLING_CODE_ID_LOADING: return {
            ...state,
            detail: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case GET_BILLING_CODE_ID_SUCCESS: return {
            ...state,
            detail: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_BILLING_CODE_ID_REJECT: return {
            ...state,
            detail: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }

        // ------------- POST --------------------
        case POST_BILLING_CODE_LOADING: return {
            ...state,
            post: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_BILLING_CODE_SUCCESS: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_BILLING_CODE_REJECT: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_BILLING_CODE_RESET: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- PUT --------------------
        case PUT_BILLING_CODE_LOADING: return {
            ...state,
            put: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_BILLING_CODE_SUCCESS: return {
            ...state,
            put: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_BILLING_CODE_REJECT: return {
            ...state,
            put: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_BILLING_CODE_RESET: return {
            ...state,
            put: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- DELETE --------------------
        case DELETE_BILLING_CODE_LOADING: return {
            ...state,
            delete: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case DELETE_BILLING_CODE_SUCCESS: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case DELETE_BILLING_CODE_REJECT: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case DELETE_BILLING_CODE_RESET: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- GET ODOO PRODUCTS --------------------
        case GET_BILLING_CODE_ODOO_LOADING: return {
            ...state,
            odooProducts: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case GET_BILLING_CODE_ODOO_SUCCESS: return {
            ...state,
            odooProducts: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_BILLING_CODE_ODOO_REJECT: return {
            ...state,
            odooProducts: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }

        default: return state;
    }
}

export default billingCodeReducer
